<div class="lemon-row">
  <div class="tuotteet_nimi lemon-cell">
    <mat-form-field style="width: 100%">
      <mat-select [formField]="parent.tuote" [compareWith]="compareTuotenimikkeet" (selectionChange)="tuoteValittu($event)" placeholder="Valitse tuote" [aria-label]="'lasku.tuote-lemonator' | translate | async">
        @for (ryhma of tuotenimikkeetRyhmat; track ryhma) {
          <mat-optgroup [label]="ryhma.kategoria">
            @for (nimike of ryhma.tuotteet; track nimike) {
              <mat-option [value]="nimike">
                {{ nimike.naytettavaNimi }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="tuotteet_lisatiedot lemon-cell">
    <mat-form-field>
      <input matInput [formField]="parent.lisatiedot" placeholder="Vapaaehtoiset lisätiedot" [attr.aria-label]="'lasku.tuote-lisatiedot' | translate | async" />
    </mat-form-field>
  </div>
  <div class="tuotteet_maara lemon-cell">
    <mat-form-field>
      <input decimalNumberField matInput [formField]="parent.maara" [numberOfDecimals]="4" [attr.aria-label]="'lasku.maara' | translate | async" />
    </mat-form-field>
  </div>
  <div class="tuotteet_ahinta lemon-cell">
    <mat-form-field>
      <input decimalNumberField matInput [formField]="parent.ahinta" [numberOfDecimals]="2" [attr.aria-label]="'lasku.a-hinta-veroton' | translate | async" />
    </mat-form-field>
  </div>
  <div class="tuotteet_alv lemon-cell">
    <mat-form-field>
      <mat-select [formField]="parent.alv" [compareWith]="compareAlvt" style="width: 100%" [aria-label]="'lasku.alv-kanta' | translate | async">
        @for (alv of alvt; track alv) {
          <mat-option [value]="alv">{{ alv.prosentti | ldecimal: 2 | async }} %</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="tuotteet_ale lemon-cell">
    <mat-form-field>
      <input decimalNumberField matInput [formField]="parent.ale" [numberOfDecimals]="4" [attr.aria-label]="'lasku.ale-pros' | translate | async" />
    </mat-form-field>
  </div>
  <div class="tuotteet_yhteensa valkoinen lemon-cell">
    <mat-form-field>
      <input decimalNumberField matInput [formField]="parent.yhteensa" [numberOfDecimals]="4" [attr.aria-label]="'lasku.tuote-yhteensa-veroton' | translate | async" />
    </mat-form-field>
  </div>
  <div class="tuotteet_poista valkoinen lemon-cell" style="text-align: center">
    <app-lemonaid-button (click)="poista()" actionId="Poista lasku rivi" class="tuotteet_poista_button" matIcon="delete"> </app-lemonaid-button>
  </div>
</div>
